<template>
  <div class="modal custom-modal fade request-modal" id="profile-court" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <div class="form-header modal-header-title">
            <h4 class="mb-0">Coach Profile</h4>
          </div>
          <a class="close" data-bs-dismiss="modal" aria-label="Close">
            <span class="align-center" aria-hidden="true"><i class="feather-x"></i></span>
          </a>
        </div>
        <div class="modal-body">
          <!-- Court Request -->
          <div class="row">
            <div class="col-lg-12">
              <div class="master-academy dull-whitesmoke-bg card master-academyview">
                <div class="row d-flex align-items-center justify-content-center">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-8">
                    <div class="d-sm-flex justify-content-start align-items-center">
                      <a href="javascript:void(0);"><img class="corner-radius-10" src="@/assets/img/master-academy.png"
                          alt="Academy" /></a>
                      <div class="info">
                        <h3 class="mb-2">Manchester Academy</h3>
                        <div class="profile-set-content w-100 p-0">
                          <ul class="bg-transparent p-0">
                            <li>
                              <img src="@/assets/img/icons/location.svg" alt="Icon" />
                              <h6>70 Bright St New York, USA</h6>
                            </li>
                            <li>
                              <img src="@/assets/img/icons/call.svg" alt="Icon" />
                              <h6>+3 80992 31212</h6>
                            </li>
                            <li>
                              <img src="@/assets/img/icons/mail.svg" alt="Icon" />
                              <h6>yourmail@example.com</h6>
                            </li>
                          </ul>
                        </div>
                        <div class="coach-profile-set">
                          <ul class="bg-transparent p-0">
                            <li>
                              <div class="coach-profile-set-img">
                                <img src="@/assets/img/icons/indoor.svg" alt="Icon" />
                              </div>
                              <div class="coach-profile-set-contemt">
                                <h5>Venue</h5>
                                <span> Indoor</span>
                              </div>
                            </li>
                            <li>
                              <div class="coach-profile-set-img">
                                <img src="@/assets/img/profiles/avatar-01.jpg" alt="Icon" />
                              </div>
                              <div class="coach-profile-set-contemt">
                                <h5>Venue</h5>
                                <span> Indoor</span>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-12 col-lg-4">
                    <ul class="d-sm-flex align-items-center justify-content-evenly">
                      <li>
                        <h3 class="d-inline-block">$150</h3>
                        <span>/hr</span>
                        <p>up to 1 guests</p>
                      </li>
                      <li>
                        <span><i class="feather-plus"></i></span>
                      </li>
                      <li class="text-center">
                        <h3 class="d-inline-block">$5</h3>
                        <span>/hr</span>
                        <p>each additional guest <br />up to 4 guests max</p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="profile-tab">
                <ul class="nav nav-tabs" role="tablist">
                  <li class="nav-item" role="presentation">
                    <button class="nav-link active" id="profile-tab1" data-bs-toggle="tab" data-bs-target="#profile1"
                      type="button" role="tab" aria-selected="true">
                      Profile Info
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button class="nav-link" id="appointment-tab1" data-bs-toggle="tab" data-bs-target="#appointment1"
                      type="button" role="tab" aria-selected="false">
                      Appointment Details
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button class="nav-link" id="reviews-tab1" data-bs-toggle="tab" data-bs-target="#reviews1"
                      type="button" role="tab" aria-selected="false">
                      Reviews
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button class="nav-link" id="previous-tab1" data-bs-toggle="tab" data-bs-target="#previous1"
                      type="button" role="tab" aria-selected="false">
                      Previous Booking
                    </button>
                  </li>
                </ul>
                <div class="tab-content">
                  <div class="tab-pane fade show active" id="profile1" role="tabpanel">
                    <div class="profile-card mb-0">
                      <div class="profile-card-title">
                        <h4>Contact Information</h4>
                      </div>
                      <div class="profile-contact-details mb-0">
                        <ul>
                          <li>
                            <span>Email Address</span>
                            <h6>contact@example.com</h6>
                          </li>
                          <li>
                            <span>Phone Number</span>
                            <h6>+1 56565 556558</h6>
                          </li>
                          <li>
                            <span> Address</span>
                            <h6>1653 Davisson Street,Indianapolis, IN 46225</h6>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane fade" id="appointment1" role="tabpanel">
                    <!-- Accordian Contents -->
                    <div class="accordion">
                      <div class="accordion-item mb-4">
                        <h4 class="accordion-header">
                          <button class="accordion-button" type="button">
                            <span class="icon-bg"><img src="@/assets/img/icons/Black.svg" alt="Icon" /></span>Overview
                          </button>
                        </h4>
                        <div class="accordion-collapse">
                          <div class="accordion-body">
                            <div class="text">
                              <p>
                                Lorem Ipsum is simply dummy text of the printing and
                                typesetting industry. Lorem Ipsum has been the industry's
                                standard dummy text ever since the 1500s, when an unknown
                                printer took a galley of type and scrambled it to make a
                                type specimen book. It has survived not only five
                                centuries, but also the leap into electronic typesetting,
                                remaining essentially unchanged. It was popularised in the
                                1960s with the release of Letraset sheets containing Lorem
                                Ipsum passages, and more recently with desktop publishing
                                software like Aldus PageMaker including versions of Lorem
                                Ipsum
                              </p>
                              <p>
                                Lorem Ipsum is simply dummy text of the printing and
                                typesetting industry. Lorem Ipsum has been the industry's
                                standard dummy text ever since the 1500s, when an unknown
                                printer took a galley of type and scrambled it to make a
                                type specimen book. It has survived not only five
                                centuries, but also the leap into electronic typesetting,
                                remaining essentially unchanged.
                              </p>
                              <p>
                                It was popularised in the 1960s with the release of
                                Letraset sheets containing Lorem Ipsum passages, and more
                                recently with desktop publishing software like Aldus
                                PageMaker including versions of Lorem IpsumLorem Ipsum is
                                simply dummy text of the printing and typesetting
                                industry. Lorem Ipsum has been the industry's standard
                                dummy text ever since the 1500s, when an unknown printer
                                took a galley of type and scrambled it to make a type
                                specimen book. It has survived not only five centuries,
                                but also the leap into electronic typesetting, remaining
                                essentially unchanged.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item mb-4">
                        <h4 class="accordion-header">
                          <button class="accordion-button" type="button">
                            <span class="icon-bg"><img src="@/assets/img/icons/lesson-with-me.svg" alt="Icon" /></span>
                            Rules
                          </button>
                        </h4>
                        <div class="accordion-collapse">
                          <div class="accordion-body">
                            <p>
                              <i class="feather-alert-octagon text-danger me-2"></i>Non
                              Marking Shoes are recommended not mandatory for Badminton.
                            </p>
                            <p>
                              <i class="feather-alert-octagon text-danger me-2"></i>A
                              maximum number of members per booking per badminton court is
                              admissible fixed by Venue Vendors
                            </p>
                            <p>
                              <i class="feather-alert-octagon text-danger me-2"></i>No
                              pets, no seeds, no gum, no glass, no hitting or swinging
                              outside of the cage
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item mb-4">
                        <h4 class="accordion-header">
                          <button class="accordion-button" type="button">
                            <span class="icon-bg"><img src="@/assets/img/icons/lesson-with-me.svg" alt="Icon" /></span>
                            Amenities
                          </button>
                        </h4>
                        <div class="accordion-collapse">
                          <div class="accordion-body">
                            <ul class="amenities-set">
                              <li>
                                <span><i class="fa fa-check-circle text-success me-2"
                                    aria-hidden="true"></i>Parking</span>
                              </li>
                              <li>
                                <span><i class="fa fa-check-circle text-success me-2" aria-hidden="true"></i>Drinking
                                  Water</span>
                              </li>
                              <li>
                                <span><i class="fa fa-check-circle text-success me-2" aria-hidden="true"></i>First
                                  Aid</span>
                              </li>
                              <li>
                                <span><i class="fa fa-check-circle text-success me-2" aria-hidden="true"></i>Change
                                  Room</span>
                              </li>
                              <li>
                                <span><i class="fa fa-check-circle text-success me-2" aria-hidden="true"></i>Shower</span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item mb-4" id="coaching">
                        <h4 class="accordion-header" id="panelsStayOpen-coaching">
                          <button class="accordion-button" type="button" data-bs-toggle="collapse"
                            data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="false"
                            aria-controls="panelsStayOpen-collapseThree">
                            <span class="icon-bg"><img src="@/assets/img/icons/includes1.svg" alt="Icon" /></span>
                            Includes
                          </button>
                        </h4>
                        <div id="panelsStayOpen-collapseThree" class="accordion-collapse collapse show"
                          aria-labelledby="panelsStayOpen-coaching">
                          <div class="accordion-body includes-set">
                            <ul>
                              <li>
                                <i class="feather-check-square"></i>Badminton Racket
                                Unlimited
                              </li>
                              <li><i class="feather-check-square"></i>Bats</li>
                              <li>
                                <i class="feather-check-square"></i>Hitting Machines
                              </li>
                              <li><i class="feather-check-square"></i>Multiple Courts</li>
                            </ul>
                            <ul>
                              <li><i class="feather-check-square"></i>Spare Players</li>
                              <li><i class="feather-check-square"></i>Instant Racket</li>
                              <li>
                                <i class="feather-check-square"></i>Hitting Machines
                              </li>
                              <li><i class="feather-check-square"></i>Green Turfs</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item mb-4">
                        <h4 class="accordion-header">
                          <button class="accordion-button" type="button">
                            <span class="icon-bg"><img src="@/assets/img/icons/gallery.svg" alt="Image" /></span>
                            Gallery
                          </button>
                        </h4>
                        <div class="accordion-collapse">
                          <div class="accordion-body">
                            <div class="owl-carousel gallery-slider owl-theme">
                              <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
                                <Slide v-for="record in BookingOne_Modal" :key="record.id">
                                  <div>
                                    <img class="img-fluid" alt="Image" :src="require(`@/assets/img/gallery/gallery4/${record.Image}`)" />
                                  </div>
                                </Slide>
                                <template #addons>
                                  <Navigation />
                                </template>
                              </Carousel>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Accordian Contents -->
                  </div>
                  <div class="tab-pane fade" id="reviews1" role="tabpanel">
                    <div class="review-box review-box-user d-flex">
                      <div class="review-profile">
                        <img src="@/assets/img/profiles/avatar-03.jpg" class="img-fluid" alt="User" />
                      </div>
                      <div class="review-info">
                        <h6 class="mb-2 tittle">Amanda Booked on 06/04/2023</h6>
                        <div class="rating">
                          <i class="fas fa-star filled me-1"></i>
                          <i class="fas fa-star filled me-1"></i>
                          <i class="fas fa-star filled me-1"></i>
                          <i class="fas fa-star filled me-1"></i>
                          <i class="fas fa-star filled me-1"></i>
                          <span class="">5.0</span>
                        </div>
                        <span class="success-text"><i class="feather-check"></i>Yes, I would book again.</span>
                        <h6>Absolutely perfect</h6>
                        <p>
                          If you are looking for a perfect place for friendly matches with
                          your friends or a competitive match, It is the best place.
                        </p>
                        <ul class="review-gallery">
                          <li v-for="(image, index) in galleryImages" :key="index" @click="() => show(index)"
                            data-aos="fade-down">
                            <a href="javascript:;" data-fancybox="gallery">
                              <img :src="require(`@/assets/img/gallery/${image.src}`)" class="img-fluid" alt="Image" />
                            </a>
                          </li>
                        </ul>
                        <span class="post-date">Sent on 11/03/2023</span>
                      </div>
                    </div>
                    <div class="review-box review-box-user d-flex">
                      <div class="review-profile">
                        <img src="@/assets/img/profiles/avatar-02.jpg" class="img-fluid" alt="User" />
                      </div>
                      <div class="review-info">
                        <h6 class="mb-2 tittle">Amanda Booked on 06/04/2023</h6>
                        <div class="rating">
                          <i class="fas fa-star filled me-1"></i>
                          <i class="fas fa-star filled me-1"></i>
                          <i class="fas fa-star filled me-1"></i>
                          <i class="fas fa-star filled me-1"></i>
                          <i class="fas fa-star filled me-1"></i>
                          <span class="">5.0</span>
                        </div>
                        <h6>Awesome. Its very convenient to play.</h6>
                        <p>
                          Lorem Ipsum is simply dummy text of the printing and typesetting
                          industry. Lorem Ipsum has been the industry's standard dummy
                          text ever since the 1500s, when an unknown printer took a galley
                          of type and scrambled it to make a type specimen book. It has
                          survived not only five centuries, but also the leap into
                          electronic!!
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane fade" id="previous1" role="tabpanel">
                    <div class="profile-card">
                      <div class="preview-tab">
                        <ul>
                          <li>
                            <div class="preview-tabcontent">
                              <div class="preview-tabimg">
                                <img src="@/assets/img/featured/featured-05.jpg" alt="Venue" />
                              </div>
                              <div class="preview-tabname">
                                <h4>Kevin Anderson</h4>
                                <h5>Onetime</h5>
                              </div>
                            </div>
                          </li>
                          <li>
                            <h6>Date & Time</h6>
                            <span class="d-block">Mon, Jul 11</span>
                            <span>06:00 PM - 08:00 PM</span>
                          </li>
                          <li>
                            <h6>$400</h6>
                          </li>
                        </ul>
                      </div>
                      <div class="preview-tab">
                        <ul>
                          <li>
                            <div class="preview-tabcontent">
                              <div class="preview-tabimg">
                                <img src="@/assets/img/featured/featured-06.jpg" alt="Venue" />
                              </div>
                              <div class="preview-tabname">
                                <h4>Evon Raddick</h4>
                                <h5>Onetime</h5>
                              </div>
                            </div>
                          </li>
                          <li>
                            <h6>Date & Time</h6>
                            <span class="d-block">Mon, Jul 11</span>
                            <span>06:00 PM - 08:00 PM</span>
                          </li>
                          <li>
                            <h6>$300</h6>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Court Request -->
        </div>
      </div>
    </div>
  </div>
  <vue-easy-lightbox :visible="visible" :index="index" :imgs="galleryImages.map((image) => ({
    src: require(`@/assets/img/gallery/${image.src}`),
  }))" @hide="visible = false" @on-prev="handlePrev" @on-next="handleNext">
  </vue-easy-lightbox>
</template>
<script>
import { Carousel, Navigation, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import BookingOne_Modal from "@/assets/json/bookingone-modal.json";
import VueEasyLightbox from "vue-easy-lightbox";
export default {
  data() {
    return {
      BookingOne_Modal: BookingOne_Modal,
      visible: false,
      index: 0,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      galleryImages: [
        {
          src: "gallery-01.jpg",
        },
        {
          src: "gallery-02.jpg",
        },
        {
          src: "gallery-03.jpg",
        },
        {
          src: "gallery-04.jpg",
        },
        {
          src: "gallery-05.jpg",
        },
      ],
      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        767: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        991: {
          itemsToShow: 2,
          snapAlign: "start",
        },
        1024: {
          itemsToShow: 3,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    VueEasyLightbox,
    Carousel,
    Slide,
    Navigation,
    VueEasyLightbox,
  },
  methods: {
    show(index) {
      this.index = index;
      this.visible = true;
    },
    handlePrev(oldIndex, newIndex) { },
    handleNext(oldIndex, newIndex) { },
  },
};
</script>
